import type { InitOptions } from 'i18next';

import {
  SupportedTranslationNamespace,
  TranslationNamespace,
  fallbackNS,
} from './types';

export const Locales = {
  EN_US: { key: 'en-US', label: 'English (US)' },
  SP_US: { key: 'es-US', label: 'Spanish (US)' },
  FR_CA: { key: 'fr-CA', label: 'Français (Canada)' },
  ZZ_ZZ: { key: 'zz-ZZ', label: 'Testing' },
};

export const DefaultLocale = Locales.EN_US.key;

export const SupportedLocales = Object.values(Locales).map(
  locale => locale.key,
);

const NAMESPACE_COMMON = TranslationNamespace.SHARED;

export const baseConfiguration: InitOptions = {
  // debug: true,
  defaultNS: NAMESPACE_COMMON,
  fallbackLng: DefaultLocale,
  fallbackNS,
  ns: SupportedTranslationNamespace,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
  supportedLngs: SupportedLocales,
};
